export default __webpack_public_path__ + "navigation-guides-free-drive-ui-1200-eba7b5e4132bb532b96f76ccb6fe5e66.png";